import type { Module } from "./module.type";
import type { UseListOptions } from "@/hooks/queries/list";

import { useList } from "@/hooks/queries";

import { MODULE_KEYS } from "./module.constant";
import { MODULE_FILTERS } from "./module.enum";

export const useModulesList = (options: UseListOptions<Module>) => {
  const { data, ...queryResult } = useList<Module>(MODULE_KEYS.LIST, options);

  return {
    modules: data?.data ?? [],
    ...queryResult,
  };
};

export const useDefaultModulesList = () => {
  return useModulesList({
    params: { [MODULE_FILTERS.IS_DEFAULT]: true },
    neverStale: true,
    persist: true, // persist data in local storage
  });
};
